import { useMemo } from 'react';
import { Moment } from '../../../shared/i18n/date-time/moment';
import { ICheckpointQueue } from '../../domain/models/ICheckpointQueue';

type LastUpdatedTime = Moment | undefined;

export function useLastUpdatedTime(
	checkpointQueues: ICheckpointQueue[] | undefined,
) {
	return useMemo(
		() =>
			checkpointQueues?.reduce((previous, checkpointQueue) => {
				const updatedAt = checkpointQueue.waitTimeUpdatedAt;

				return !previous || updatedAt.isAfter(previous) ? updatedAt : previous;
			}, undefined as LastUpdatedTime),
		[checkpointQueues],
	);
}
